import { siteMeta, stats, testimonials } from "@/mocks/gossipData";

const principles = [
  { icon: "ri-time-line", title: "更新及时", text: "每日跟进焦点事件最新进展，周五固定推出本周盘点，不让热点断片。" },
  { icon: "ri-checkbox-circle-line", title: "来源较清", text: "多方信源交叉核对，存疑传闻明确标注「网传·待证实」，避免以讹传讹。" },
  { icon: "ri-stack-line", title: "栏目清晰", text: "娱乐八卦 / 影视综艺 / 人物话题 / 社会热议四大栏目，按需速读。" },
  { icon: "ri-heart-line", title: "理性吃瓜", text: "客观整理近期动态，不煽动对立，把判断空间留给你自己。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary-600">About {siteMeta.brand}</p>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              关于 {siteMeta.brand}
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-foreground-700">
              {siteMeta.brand}是一份「轻量级」的本周吃瓜焦点周刊。我们相信，了解近期动态不该被碎片化的热搜淹没。
              因此编辑部每天筛选、每天追踪，把娱乐八卦与社会热议里真正有来龙去脉的话题整理在一起。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
              无论是通勤路上的十分钟，还是午休时的一口气，你都能用最短时间把本周焦点补完。
              我们不制造流量、不炮制谣言，只做信息的「整理者」与「搬运工」。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-lg bg-background-100 p-3 text-center ring-1 ring-background-200">
                  <p className="font-heading text-base font-black text-primary-600">{s.num}</p>
                  <p className="mt-1 text-[11px] text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-7 grid gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-3 rounded-lg bg-background-100 p-4 ring-1 ring-background-200">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={p.icon + " text-lg"}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{p.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary-600">Reader Words</p>
            <h3 className="font-heading mt-2 text-2xl font-black text-foreground-950">读者口碑</h3>
            <div className="mt-6 space-y-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-xl bg-background-100 p-5 ring-1 ring-background-200">
                  <div className="flex gap-1 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                      {t.name.slice(0, 1)}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}